module.exports = __webpack_public_path__ + "img/new-treatment.07117b6c.png";